import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=14731605&scoped=true&"
var script = {}
import style0 from "./Products.vue?vue&type=style&index=0&id=14731605&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14731605",
  null
  
)

export default component.exports